import { useGetApiV1LocationCountriesDropdown } from '@/shared/api/generated';

/**
 * Hook para as opções de País (dropdown) usadas no seletor do formulário de
 * Estado. Envolve `GET /api/v1/location/countries/dropdown`, que retorna
 * `{ key, value }[]` (key = id do país, value = nome).
 */
export function useCountryDropdown() {
  const query = useGetApiV1LocationCountriesDropdown();

  return {
    options: query.data ?? [],
    isLoading: query.isLoading,
  } as const;
}
